import { Component } from "react";
import AzureRequest from "@/services//request";
import Card from "@/components/card";
import LinkButton from "@/components/linkButton";
import SearchField from "@/components/searchField";
import Title from "@/components/title";


class Home extends Component {

  constructor(props) {
    super(props);
    this.request = new AzureRequest();
    this.state = { 
      didYouKnow: '',
      isLoading: false,
      error: null
    };
    
  }

  componentDidMount() {
    this.setState({isLoading: true})
    this.request.post({
      filter: "LE_SAVIEZ_VOUS_ ne null",
      top: 1000
    }).then((response) => {
      const randomCourse = response.value[Math.floor(Math.random() * response.value.length)];
      this.setState({
        didYouKnow: <>{randomCourse.LE_SAVIEZ_VOUS_}<br/>{randomCourse.LE_SAVIEZ_VOUS_1}</>,
        isLoading: false
      });
    }).catch((error) => this.setState({error, isLoading: false}))
  }

  


  render() { 
    return (
      <section className="relative z-10 container md:w-3/4 w-11/12 md:-mt-32 -mt-8 mb-20 mx-auto flex flex-col items-center">
        <h2 className="mb-4 py-2 px-6 uppercase text-2xl bg-white bg-opacity-75">Mes services orientation</h2>
        <div className="grid lg:grid-cols-3 grid-cols-1 lg:grid-rows-5 gap-8">
          <Card 
            width="1"
            height="3"
            justify="center"
            background="gray-darkest"
            textColor="white"
            image="milky-way"
            imagePosition="right"
          >
            <Title
              title="Galaxie 3D des formations"
              subtitle="J'explore l'univers des formations et des domaines professionnels"
              justify="center"
              level="3"
            />
            <div className="mt-10">
              <LinkButton
                label="J'explore"
                link="/explorer"
                padding="4"
              />
            </div>
          </Card>
          <div className="lg:col-span-2 col-span-1 lg:row-span-3 row-span-1 grid grid-cols-1">
            <Card 
              width="1"
              height="1"
              justify="center"
              background="gray-medium"
              secondaryBg="gray-light"
              textColor="white"
              image="open-book"
              imagePosition="right-top"
            >
              <Title
                title="Répertoire des formations"
                subtitle="Je recherche une formation par filière ou domaine professionnel"
                level="3"
                justify="center"
              />
              <div className="flex justify-center items-center w-11/12 gap-2 mb-2">
                <SearchField handleChange={this.props.handleSearchChange} />
                <LinkButton 
                  label={
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  }
                  link="rechercher"
                  targetState={this.state.courseSearch}
                  padding = '2'
                /> 
              </div>
            </Card>
            <Card
              width="1"
              height="1"
              justify="center"
              background="gray-light"
              secondaryBg="gray-light"
              textColor="white"
              content="repertoire"
            >
              <h3 className="font-t-semibold text-xl my-2" >Le saviez vous ?</h3>
              <p className="text-lg text-center mb-8 px-2">{this.state.didYouKnow}</p>
              <LinkButton 
                label="Rechercher par filtres"
                link="rechercher"
                targetState={this.state.courseSearch}
                padding="4"
              />
            </Card>
          </div>
          <Card
            width="3"
            height="2"
            justify="center"
            background="gray-dark"
            textColor="white"
            image="telescope"
            imagePosition="right-bottom"
            content=""
          >
            <Title
              title="Découverte des formations"
              subtitle="Je découvre au hasard des domaines professionnels et des formations"
              level="3"
              justify="center"
            />
            <div className="mt-10">
              <LinkButton
                label="Je découvre"
                link="/decouvrir"
                padding="4"
              />
            </div>
          </Card>
        </div>
      </section>
    );
  }
}
 
export default Home;